export const SENTRY_VERSION = 'PROD-EU-f7c5893b7c0b2353b181afe9734351c4a8eebe33';
